import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter as Router } from "react-router-dom";

import store, { persistor } from "./store/store";
import LayoutComponent from "./components/layout/LayoutComponent";
import LoaderComponent from "./components/loader/LoaderComponent";
import { useActivityLogger } from "./hooks/useActivityLogger";
import { useEffect } from "react";


function CustomRouter({ basename, children }) {
  // Check if the current URL starts with the basename
  const shouldRender = window.location.pathname.startsWith(basename);
  console.log("window.location", window.location.pathname)
  console.log("basename", basename)
  console.log("shouldRender", shouldRender)

  // If the URL doesn't match the basename, redirect to the basename
  if (!shouldRender) {
    window.location.href = basename;
    return null; // Return null to prevent rendering anything
  }

  // If the URL matches the basename, render the Router with the provided basename and children
  return <Router basename={basename}>{children}</Router>;
}
//call worker at the top

function ActivityLoggerWrapper() {
  useActivityLogger();
  return null; // doesn't render anything
}

function App() {
  useEffect(() => {
    if ('Worker' in window) {
      const worker = new Worker(`${process.env.PUBLIC_URL}/activity.worker.js`); // Note: path is relative to public root
      worker.onerror = (e) => {
        console.error('Worker error:', e.message, e.filename, e.lineno);
      };
      console.log('Activity worker registered');
    }
  }, []);



  return (
    <CustomRouter basename="/console">
      
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          
          <LoaderComponent>
            <LayoutComponent />
            <ActivityLoggerWrapper />
          </LoaderComponent>
        </PersistGate>
      </Provider>
    </CustomRouter>
  );
}

export default App;
